import React, { useContext } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import FormContext from 'src/presentation/contexts/FormContext';
import StackContainer from '@ad-scripts/presentation/components/common/containers/stack_container';
import { StyledBold } from 'src/presentation/components/pages/channels/shared/setupPhoneModal/templates/shared/elements';
import useDefaultSlaMinutes from 'src/presentation/components/pages/channels/entryPoints/hooks/useDefaultSlaMinutes';
import { convertTimeUnit } from '@ad-scripts/presentation/components/common/input_with_time_convert_field';
import { TimeUnits } from 'src/presentation/components/pages/shared/MinutesInputField';

export default function SectionHeaderTitleAndDescription({
  'data-aid': dataAid,
  entryPoints,
  inboxesMap,
  item,
}): JSX.Element {
  const { workingState } = useContext(FormContext);

  const defaults = get(workingState, 'defaultsIds', []);

  const defaultSlaMinutes = useDefaultSlaMinutes({ baseAttr: '', inboxesMap });

  const slaSeconds = get(workingState, 'slaSeconds');

  const minutes = convertTimeUnit(
    TimeUnits.Seconds,
    TimeUnits.Minutes,
    slaSeconds ? slaSeconds : defaultSlaMinutes * 60,
    true
  ).toString();

  const inbox = get(inboxesMap[get(workingState, 'routingGroupId') as any], 'name', '');

  const nameInDescription = item.nameInDescription;

  const numberOfDefaultEntryPoints = defaults.length;

  return (
    <SectionDescription data-aid={`${dataAid}-description`}>
      <span>
        By default, all inbound {nameInDescription} will be routed to <StyledBold>{inbox}</StyledBold> with an SLA of{' '}
        <StyledBold>{minutes} minutes</StyledBold>. This setting applies to{' '}
        <StyledBold>
          {numberOfDefaultEntryPoints} of {entryPoints?.length} Entry Points
        </StyledBold>
        .
      </span>
    </SectionDescription>
  );
}

export const SectionDescription = styled(StackContainer).attrs({ stack: 'none', inset: 'none' })`
  color: ${p => p.theme.colors.black};
  line-height: ${p => p.theme.lineHeight.base};
  margin-top: ${p => p.theme.spacing.insetMedium};
  width: 100%;
`;
